import {Component, computed, input} from '@angular/core';
import {ArrowRightFromLineIcon, ArrowRightToLineIcon, LucideAngularModule} from 'lucide-angular';
import {TimeUtil} from '@shared/util/time.util';
import {ActivityScheduleDTO} from '@domain/activity/schedule/schedule.dto';
import {WeekdayPipe} from '@domain/common/pipe/weekday.pipe';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {ActivityScheduleUtil} from '@domain/activity/schedule/activity-schedule.util';

@Component({
  selector: 'app-schedule-validity',
  imports: [
    LucideAngularModule
  ],
  providers: [
    WeekdayPipe
  ],
  templateUrl: './schedule-validity.component.html'
})
export class ScheduleValidityComponent {

  public readonly activity = input.required<ActivityDTO>();
  public readonly schedule = input.required<ActivityScheduleDTO>();

  public readonly highlight = input(false);

  public readonly isNotYetValid = computed(() => ActivityScheduleUtil.isNotYetValid(this.schedule()));
  public readonly validFrom = computed(() => this.isNotYetValid() ? `du ${TimeUtil.formatDate(this.schedule().validFrom)}` : null);
  public readonly isExpiringSoon = computed(() => ActivityScheduleUtil.isExpiringSoon(this.schedule()));
  public readonly validUntil = computed(() => this.isExpiringSoon() ? `jusqu'au ${TimeUtil.formatDate(this.schedule().validUntil)}` : null);

  public readonly icons = {
    since: ArrowRightFromLineIcon,
    until: ArrowRightToLineIcon
  };

}
